import React, { useEffect, useState } from 'react';

export default function SettingsModal({ settings, onChange, onClose }) {
    const [localSettings, setLocalSettings] = useState(settings);

    useEffect(() => {
        setLocalSettings(settings);
    }, [settings]);

    function handleSave() {
        onChange(localSettings);
        onClose();
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <h2>Settings</h2>
                <form>
                    <label>
                        Red team name:
                        <input
                            type="text"
                            value={localSettings.redTeamName}
                            onChange={(e) => setLocalSettings({ ...localSettings, redTeamName: e.target.value })}
                        />
                    </label>
                    <label>
                        Blue team name:
                        <input
                            type="text"
                            value={localSettings.blueTeamName}
                            onChange={(e) => setLocalSettings({ ...localSettings, blueTeamName: e.target.value })}
                        />
                    </label>
                    <label>
                        Target score:
                        <input
                            type="number"
                            min="1"
                            value={localSettings.targetScore}
                            onChange={(e) => {
                                const val = parseInt(e.target.value, 10) || 1;
                                setLocalSettings({
                                    ...localSettings,
                                    targetScore: val,
                                    maxScore: Math.max(val, localSettings.maxScore)
                                });
                            }}
                        />
                    </label>
                    <label>
                        Win by:
                        <input
                            type="number"
                            min="1"
                            value={localSettings.winBy}
                            onChange={(e) => setLocalSettings({
                                ...localSettings,
                                winBy: parseInt(e.target.value, 10) || 1
                            })}
                        />
                    </label>
                    <label>
                        Max score:
                        <input
                            type="number"
                            min={localSettings.targetScore}
                            value={localSettings.maxScore}
                            onChange={(e) => setLocalSettings({
                                ...localSettings,
                                maxScore: Math.max(localSettings.targetScore, parseInt(e.target.value, 10) || localSettings.targetScore)
                            })}
                        />
                    </label>
                </form>
                <div className="modal-actions">
                    <button type="button" onClick={handleSave}>Done</button>
                    <button type="button" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}
